import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";

export default function Terms() {
  return (
    <>
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="label-tag mb-3">Documento legale</div>
        <h1 className="font-display font-black text-4xl md:text-5xl uppercase tracking-tighter text-gray-900 mb-2">
          Termini di<br /><span className="text-[#E11D48]">servizio</span>
        </h1>
        <p className="text-sm text-gray-500 mb-10">Ultimo aggiornamento: 12 maggio 2026</p>

        <section className="prose prose-sm md:prose-base text-gray-500 space-y-6">
          <p>
            Benvenuto su Bicyclub. Iscrivendoti o utilizzando questo servizio accetti i presenti Termini di Servizio.
            Ti chiediamo di leggerli con attenzione.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">1. Cos'è Bicyclub</h2>
          <p>
            Bicyclub è una piattaforma social gratuita rivolta a ciclisti italiani che vogliono trovare compagni di giro,
            pubblicare uscite in bicicletta, coordinare la partenza e chattare con il gruppo.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">2. Iscrizione</h2>
          <p>
            Per usare Bicyclub devi avere almeno <strong>16 anni</strong>. Fornisci dati veritieri al momento dell'iscrizione.
            Sei responsabile della custodia delle tue credenziali (password) e di tutte le attività svolte dal tuo account.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">3. Comportamento accettabile</h2>
          <p>Quando usi Bicyclub ti impegni a:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Rispettare gli altri utenti, evitare insulti, molestie, discriminazioni di ogni tipo.</li>
            <li>Pubblicare informazioni veritiere sui giri (data, ora, luogo, percorso, difficoltà).</li>
            <li>Non utilizzare la piattaforma per scopi commerciali senza autorizzazione (es. vendita di servizi, sponsorizzazioni mascherate da giri).</li>
            <li>Non caricare contenuti che violino diritti d'autore o di terzi.</li>
            <li>Non tentare di compromettere la sicurezza della piattaforma (bot, scraping, attacchi).</li>
          </ul>
          <p>
            In caso di violazione, ci riserviamo il diritto di sospendere o cancellare il tuo account senza preavviso.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">4. Responsabilità durante i giri</h2>
          <p>
            <strong>Importante</strong>: Bicyclub è una piattaforma di incontro tra ciclisti. Non organizziamo direttamente
            i giri, non siamo presenti, non li supervisioniamo. Ogni utente che pubblica o partecipa a un giro lo fa
            <strong> sotto la propria responsabilità personale</strong>.
          </p>
          <p>
            Bicyclub <strong>non è responsabile</strong> per:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Incidenti, infortuni o danni a persone o cose durante o a causa di un giro.</li>
            <li>Comportamenti scorretti, illeciti o negligenti degli altri partecipanti.</li>
            <li>Affidabilità delle informazioni fornite (un giro potrebbe essere annullato all'ultimo momento).</li>
            <li>Rispetto del Codice della Strada da parte dei partecipanti.</li>
          </ul>
          <p>
            Indossa sempre il casco, rispetta il Codice della Strada, valuta autonomamente se le tue capacità sono
            adeguate al giro (km, dislivello, ritmo dichiarato).
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">5. Contenuti generati dagli utenti</h2>
          <p>
            Pubblicando un giro o un messaggio in chat, ci concedi una licenza limitata e non esclusiva per mostrare quel
            contenuto agli altri utenti della piattaforma. Resti proprietario dei tuoi contenuti.
          </p>
          <p>
            Ci riserviamo il diritto di rimuovere contenuti che violino questi Termini, senza preavviso.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">6. Servizi terzi</h2>
          <p>
            Bicyclub integra Strava, Komoot, Google (OAuth), Resend (email), OpenStreetMap (mappe). L'uso di questi
            servizi è regolato anche dai rispettivi termini.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">7. Costi</h2>
          <p>
            Bicyclub è attualmente <strong>gratuito</strong>. Ci riserviamo il diritto di introdurre in futuro piani a
            pagamento per funzionalità premium. Le funzionalità di base resteranno gratuite per gli utenti già iscritti.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">8. Limitazione di responsabilità</h2>
          <p>
            Nei limiti consentiti dalla legge, Bicyclub fornisce il servizio "così com'è" senza garanzie di
            disponibilità continuativa, assenza di errori o adeguatezza a scopi specifici. La nostra responsabilità
            economica massima verso un singolo utente è limitata a 0€, essendo il servizio gratuito.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">9. Modifiche</h2>
          <p>
            Possiamo modificare questi Termini in qualsiasi momento. Le modifiche significative verranno notificate via
            email. L'uso continuato del servizio dopo le modifiche costituisce accettazione dei nuovi Termini.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">10. Cancellazione account</h2>
          <p>
            Puoi cancellare il tuo account in qualsiasi momento scrivendo a
            <a href="mailto:info@bicyclub.it" className="text-[#E11D48] underline ml-1">info@bicyclub.it</a>.
            Eseguiremo la cancellazione entro 30 giorni.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">11. Legge applicabile</h2>
          <p>
            Questi Termini sono regolati dalla legge italiana. Per qualsiasi controversia è competente il Foro di
            residenza dell'utente consumatore.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">Contatti</h2>
          <p>
            Per qualsiasi domanda scrivi a
            <a href="mailto:noinforeply@bicyclub.it" className="text-[#E11D48] underline ml-1">info@bicyclub.it</a>.
          </p>
        </section>

        <div className="mt-12 pt-6 border-t border-gray-200 flex flex-wrap gap-4">
          <Link to="/privacy" className="text-xs uppercase tracking-wider font-bold text-gray-700 hover:text-gray-900">← Privacy</Link>
          <Link to="/" className="text-xs uppercase tracking-wider font-bold text-gray-700 hover:text-gray-900">Home</Link>
        </div>
      </main>
    </>
  );
}
